import {
  ControlMapping,
  DynamoDBQueryResponse,
  MappingReview,
  ReviewQueryParams,
} from '../../types/dynamodb';
import { NexusApiService } from '../nexusApiService';

/**
 * Backend-aligned UI client for NexusMappingReviewService APIs.
 */
export class NexusMappingReviewService {
  constructor(private readonly api: NexusApiService) {}

  async listReviewsForMapping(
    mappingId: string,
    params?: { maxResults?: number; nextToken?: string }
  ): Promise<{ mappingKey: string; reviews: any[]; count: number; nextToken?: string }> {
    return this.api.listReviewsForMapping(mappingId, params);
  }

  async getReviewsForMapping(
    mappingKey: string,
    mapping?: ControlMapping
  ): Promise<MappingReview[]> {
    return this.api.getReviewsForMapping(mappingKey, mapping);
  }

  async getReviewsByReviewer(
    params: ReviewQueryParams
  ): Promise<DynamoDBQueryResponse<MappingReview>> {
    return this.api.getReviewsByReviewer(params);
  }

  async submitReview(
    review: Omit<MappingReview, 'reviewKey' | 'submittedAt'>
  ): Promise<void> {
    return this.api.submitReview(review);
  }

  async suggestMapping(params: {
    controlKey: string;
    mappedControlKey: string;
    reviewerId: string;
    reviewerName: string;
    justification: string;
  }): Promise<void> {
    return this.api.suggestMapping(params);
  }

  async submitLabel(params: {
    mappingKey: string;
    controlKey: string;
    mappedControlKey: string;
    reviewerId: string;
    reviewerName: string;
    decision: 'label-yes' | 'label-no';
    feedback?: string;
  }): Promise<void> {
    return this.api.submitLabel(params);
  }
}
